import Parse from 'html-react-parser';

function BMP20239(props) {
    let svgCode =
    `<svg width="1800" height="1272" viewBox="0 0 1800 1272" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .boxStyle rect {
        ${props.boxStyle}
    }
    ${props.fontFace}
    </style>
    <g class="boxStyle">
        <rect width="1800" height="1272" fill="${props.backgroundFill}"/>
        <rect x="23" y="464" width="90" height="531" rx="4" fill="${props.paramFill}"/>
        <rect x="125" y="464" width="1549" height="531" fill="${props.paramFill}"/>
        <rect x="126" y="64" width="1547" height="347" fill="${props.paramFill}"/>
        <rect x="1687" y="80" width="90" height="43" rx="5" fill="${props.paramFill}"/>
        <rect x="725" y="1058" width="993" height="43" rx="4" fill="${props.paramFill}"/>
        <rect x="1586" y="1004" width="88" height="43" rx="4" fill="${props.paramFill}"/>
        <rect x="23" y="1058" width="165" height="43" rx="4" fill="${props.paramFill}"/>
        <rect x="1688" y="952" width="88" height="43" rx="4" fill="${props.paramFill}"/>
        <rect x="40" y="334" width="56" height="70" fill="${props.highlightColourB}"/>
        <path d="M52 388.5L58 380L64 392L69.5 387H84" stroke="${props.fontColour}" stroke-width="4"/>
        <line x1="56" y1="352" x2="72" y2="352" stroke="${props.fontColour}" stroke-width="4"/>
        <line x1="58" y1="352" x2="58" y2="368" stroke="${props.fontColour}" stroke-width="4"/>
        <path d="M86 352L71 362.392L71 341.608L86 352Z" fill="${props.fontColour}"/>
        <rect x="590" y="1062" width="52" height="34" rx="3" fill="${props.highlightColourB}"/>
        <path d="M606.126 1080.05L606.005 1069.57L616.616 1079.99L606.126 1080.05Z" fill="${props.fontColour}"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M617.719 1073.98C616.254 1073.84 614.428 1074.37 612.674 1076.33L609.693 1073.67C612.189 1070.88 615.216 1069.72 618.092 1069.99C620.913 1070.26 623.382 1071.88 624.801 1074.21C626.241 1076.58 626.578 1079.64 625.234 1082.7C623.906 1085.71 621.026 1088.54 616.374 1090.8L614.626 1087.2C618.724 1085.21 620.742 1082.97 621.573 1081.08C622.389 1079.23 622.147 1077.55 621.383 1076.29C620.598 1075 619.238 1074.12 617.719 1073.98Z" fill="${props.fontColour}"/>
        <rect width="52" height="34" rx="3" transform="matrix(-1 0 0 1 698 1062)" fill="${props.highlightColourB}"/>
        <path d="M681.874 1080.05L681.995 1069.57L671.384 1079.99L681.874 1080.05Z" fill="${props.fontColour}"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M670.281 1073.98C671.746 1073.84 673.572 1074.37 675.326 1076.33L678.307 1073.67C675.811 1070.88 672.784 1069.72 669.908 1069.99C667.087 1070.26 664.618 1071.88 663.199 1074.21C661.759 1076.58 661.422 1079.64 662.766 1082.7C664.094 1085.71 666.974 1088.54 671.626 1090.8L673.374 1087.2C669.276 1085.21 667.258 1082.97 666.427 1081.08C665.611 1079.23 665.853 1077.55 666.617 1076.29C667.402 1075 668.762 1074.12 670.281 1073.98Z" fill="${props.fontColour}"/>
        <rect x="446" y="1062" width="112" height="34" rx="3" fill="${props.highlightColourB}"/>
        <rect x="330" y="1062" width="112" height="34" rx="3" fill="${props.highlightColourB}"/>
        <rect x="258" y="1062" width="40" height="34" rx="3" fill="${props.highlightColourB}"/>
        <rect x="214" y="1062" width="40" height="34" rx="3" fill="${props.highlightColourB}"/>
        <rect x="226" y="1078" width="16" height="4" fill="${props.fontColour}"/>
        <path d="M270 1078H286V1082H270V1078Z" fill="${props.fontColour}"/>
        <path d="M276 1088V1072H280V1088H276Z" fill="${props.fontColour}"/>
        <g fill="${props.fontColour}" font-family="${props.fontName}" font-weight="${props.fontExtras.weight}" letter-spacing="${props.fontExtras.space}">
        <text font-size="18"><tspan x="378" y="1085.65">COPY</tspan></text>
        <text font-size="18"><tspan x="493" y="1085.65">PASTE</tspan></text>
        <text font-size="16"><tspan x="1711" y="1033.97">GRID</tspan></text>
        <text font-size="16"><tspan x="1705" y="147.969">ZOOM</tspan></text>
        </g>
        <rect x="1694" y="866" width="36" height="30" rx="4" fill="${props.highlightColourB}"/>
        <path d="M1720 885L1712 878L1704 885M1712 878L1704 885" stroke="${props.fontColour}" stroke-width="5"/>
        <rect width="36" height="30" rx="4" transform="matrix(1 0 0 -1 1694 934)" fill="${props.highlightColourB}"/>
        <path d="M1720 917L1712 924L1704 917M1712 924L1704 917" stroke="${props.fontColour}" stroke-width="5"/>
        <rect width="36" height="30" rx="4" transform="matrix(1 0 0 -1 1486 1040)" fill="${props.highlightColourB}"/>
        <rect width="36" height="30" rx="4" transform="matrix(1 0 0 -1 1530 1040)" fill="${props.highlightColourB}"/>
        <path d="M1508 1033L1501 1025L1508 1017M1501 1025L1508 1017" stroke="${props.fontColour}" stroke-width="5"/>
        <path d="M1544 1033L1551 1025L1544 1017M1551 1025L1544 1017" stroke="${props.fontColour}" stroke-width="5"/>
        <rect width="36" height="30" rx="4" transform="matrix(1 0 0 -1 1734 1094)" fill="${props.highlightColourB}"/>
        <path d="M1752 1086L1760.66 1074H1743.34L1752 1086Z" fill="${props.fontColour}"/>
        <rect width="1800" height="66" fill="${props.paramFill}"/>
    </g>
    </svg>`

    props.svgReturn(80, svgCode, "bmp00239", 1800, 1272);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20239;